<div class="flex justify-center" style="height: inherit">
  @if (shouldShowImage) {
    <img
      mat-card-image
      [src]="offer.imageUrl"
      [alt]="'Photo of ' + offer.name"
      class="object-contain"
      />
  }

  <!-- YouTube Video display -->
  @if (shouldShowVideo) {
    <iframe
      [src]="safeVideoUrl"
      class="w-full h-full"
      frameborder="0"
      allow=""
      allowfullscreen
      >
    </iframe>
  }

  <!-- PDF display -->
  @if (shouldShowPdf) {
    <div
      class="w-full h-full flex items-center justify-center"
      (click)="downloadPdf()"
      tabindex="0"
      role="button"
      (keyup.enter)="downloadPdf()"
      >
      <p class="hover:cursor-pointer flex flex-col items-center">
        <mat-icon style="font-size: 100px; width: 100px; height: 100px"
          >picture_as_pdf</mat-icon
          >
          @if (showDownloadPdf) {
            <span
              class="text-sm text-gray-600 mt-4 flex items-center"
              >
              <mat-icon>download</mat-icon>
              Dokument herunterladen
            </span>
          }
        </p>
      </div>
    }
  </div>
